import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const billPaymentType = {
  'Billing::BankSlipPayment': 'Boleto',
  'Billing::WalletPayment': 'Carteira',
  'Billing::EstablishmentAuthorizationPayment': 'Autorização de Pagamento',
};

export const billPaymentOptions = strategyToOptions(billPaymentType);
